export default __webpack_public_path__ + "cc59ffcf13fe9ab78c058bb870ba61d0.jpg";